const pageId = {
    mint: 'mint', 
    chat: 'chat'
}

export default pageId;